import enUS from "./en-us";
import ruRU from "./ru-ru";
var languages = {
  'ru-ru': ruRU,
  'en-us': enUS
};
export default languages;